<template>
  <div>
    <p>
        <el-checkbox  v-model="zdItem.isChecked" :disabled="getAuthShow()">{{ zdItem.text }}</el-checkbox>
    </p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import base from "@/common/base.js";
export default {
  name: "ZDNoteText", 
  props: {
    zdId: {
      type: String,
      required: true,
    }
  },
  computed: {
    // 从 Vuex 获取当前组件的整个状态
    ...mapGetters("zdInput", {
      zdGetComponentState: "getComponentState",
    }),
    getAuthShow(){
      return base.getAuthShow();
    },
    // 获取当前组件的状态对象
    zdComponentState() {
      return this.zdGetComponentState(this.zdId);
    },
    // 从状态对象中获取各个字段
    zdItem() {
      return this.zdComponentState;
    },
    labelText() {
      return (label) => {
        // console.info('this.zdItem:',this.zdItem)
        let key = "content." + label;
        key = key.toLowerCase().replaceAll(" ", "_");
        return this.$t(key);
      };
    },
    zdFormattedValue: {
      get() {
        let val = "";
        if(Array.isArray(this.zdItem.value)){
          val = this.zdItem.value.join(",");
        }else {
          val =  this.zdItem.value || ""
        }
        return val; // 获取输入框的值
      },
      set(value) {
        this.zdUpdateComponent({
          id: this.zdId,
          field: "value",
          value: value,
        }); // 更新输入框的值
      },
    },
  },
  created() {
    // if(this.zdItem.label=='Notes'){
    //   console.info('zid:',this.zdId)
    // }
    // console.log("created:", this.zdItem);
  },
  methods: {
    // 映射 Vuex 的动作
    ...mapActions("zdInput", ["updateComponent"]),
    zdUpdateComponent(payload) {
      this.updateComponent(payload); // 更新组件状态
    },
    inputChange(value){
      console.info(value)
      this.zdUpdateComponent({
          id: this.zdId,
          field: "value",
          value: value,
        }); // 更新输入框的值
    }
  },
};
</script>
